import React from "react";
import { TransactionsReversals } from "../../../../components/Transactions";

class RefundTransactionsScreen extends React.Component {
  render() {
    return <TransactionsReversals />;
  }
}

export default RefundTransactionsScreen;
